import { createContext, useContext, useState, useCallback } from 'react'

const FullScreenContext = createContext()

export const FullScreenProvider = ({ children }) => {
  const [isFullScreen, setIsFullScreen] = useState(false)

  const toggleFullScreen = useCallback(() => {
    setIsFullScreen(prev => !prev)
  }, [])

  const exitFullScreen = useCallback(() => {
    setIsFullScreen(false)
  }, [])

  return (
    <FullScreenContext.Provider
      value={{ isFullScreen, toggleFullScreen, exitFullScreen }}
    >
      {children}
    </FullScreenContext.Provider>
  )
}

export const useFullScreen = () => useContext(FullScreenContext)
